import { Pipe, PipeTransform } from '@angular/core';
import { NameFormat, UserName } from '@shared/types/user.type';

@Pipe({
  name: 'fullName',
})
export class FullNamePipe implements PipeTransform {
  transform(
    user: UserName | null | undefined,
    format: NameFormat = 'firstLast',
  ): string {
    if (!user) {
      return 'N/A';
    }

    // Handle both snake_case and camelCase property names
    const firstName = user.first_name ?? user.firstName ?? '';
    const lastName = user.last_name ?? user.lastName ?? '';

    if (!firstName && !lastName) {
      return 'N/A';
    }

    if (format === 'lastFirst') {
      return `${lastName}, ${firstName}`.trim();
    }
    return `${firstName} ${lastName}`.trim();
  }
}
